/** @jsx jsx */
import { AboutUsPage } from '@composite';
import { Layout, StaticSEO } from '@core';
import { jsx } from 'theme-ui';

const AboutUs = () => (
  <Layout>
    <StaticSEO pageId='about-us' />
    <AboutUsPage />
  </Layout>
);

export default AboutUs;
